import { SET_ETAPE_ACTIVE } from './etapesActions';

const initialState = {
    etapeActive: 1,
};

const etapesReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SET_ETAPE_ACTIVE:
            return {
                ...state,
                etapeActive: action.payload,
            };
        default:
            return state;
    }
};

export default etapesReducer;
